/** What the environment banner shows for BACKOFFICE_ENV (validated server-side in main.ts). */
export type EnvironmentTone = 'development' | 'staging' | 'demo' | 'production';

export interface EnvironmentInfo {
  key: string;
  label: string;
  tone: EnvironmentTone;
}

const KNOWN: Record<string, EnvironmentInfo> = {
  dev: { key: 'dev', label: 'Development', tone: 'development' },
  stage: { key: 'stage', label: 'Staging', tone: 'staging' },
  demo: { key: 'demo', label: 'Demo', tone: 'demo' },
  eu: { key: 'eu', label: 'Production · EU', tone: 'production' },
  prd: { key: 'prd', label: 'Production', tone: 'production' },
  global: { key: 'global', label: 'Production · Global', tone: 'production' },
  social: { key: 'social', label: 'Production · Social', tone: 'production' },
};

/** Unknown values are shown as production: the safe assumption is that edits are real. */
export function environmentInfo(backofficeEnv: string): EnvironmentInfo {
  const key = backofficeEnv.trim().toLowerCase();
  return KNOWN[key] ?? { key, label: `Unknown environment (${key || 'unset'})`, tone: 'production' };
}
